import React, { createRef, useState } from 'react'
import styled from 'styled-components'
import { CaretRightFilled, PauseOutlined } from '@ant-design/icons'

interface VideoContainerProps {
  videoPath: string
  controlsColour: string
}

export const VideoContainer = (props: VideoContainerProps) => {
  const { videoPath, controlsColour } = props
  const videoRef = createRef<HTMLVideoElement>()
  const [isPlaying, setVideo] = useState(true) // video plays by default
  const IconPause = styled(PauseOutlined)`
    width: inherit;
    height: inherit;
    border-radius: 25px;
  `

  const IconPlay = styled(CaretRightFilled)`
    width: inherit;
    height: inherit;
    border-radius: 25px;
  `

  const toggleVideoPlaying = () => {
    const video = videoRef.current
    if (!video) {
      return
    }
    if (isPlaying) {
      video.pause()
      setVideo(false)
    } else {
      video.play()
      setVideo(true)
    }
  }
  return (
    <>
      <Toggle
        onClick={() => {
          toggleVideoPlaying()
        }}
      >
        {isPlaying ? (
          <IconPause style={{ color: controlsColour }} />
        ) : (
          <IconPlay style={{ color: controlsColour }} />
        )}
      </Toggle>
      <LeftVideo
        id="video"
        ref={videoRef}
        // style={{ objectPosition: settings.objectPosition }}
        playsInline
        autoPlay
        muted
        loop
        preload="metadata"
      >
        <source src={`${videoPath}#t=0.1`} type="video/mp4" />
        {/* add WEBM videos? */}
      </LeftVideo>
    </>
  )
}

const LeftVideo = styled.video`
  width: 30vw;
  height: 100%;
  object-fit: cover;
  object-position: left;

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  // @media (max-width: 1025px) {
  //   display: none;
  // }
`
const Toggle = styled.button`
  position: absolute;
  width: 3rem;
  height: 3rem;
  bottom: 4rem;
  border-radius: 25px;
  // background-color: rgba(0.2, 0.4, 0, 0.5);
  left: 50%;
  transform: translate(-50%, -50%);
  border: none;
  z-index: 1;
`
